package com.artvending.warden.screens.home


import androidx.compose.runtime.Composable
import com.artvending.warden.Card
import com.artvending.warden.Column_
import com.artvending.warden.MdLinearProgress
import com.artvending.warden.MyButton
import com.artvending.warden.Row_
import com.artvending.warden.StackScope
import com.artvending.warden.TimelineUnit
import com.artvending.warden.TimelineUnitMode
import com.artvending.warden.allowDevice
import com.artvending.warden.fixedInterval
import com.artvending.warden.getDayOfWeekStr
import com.artvending.warden.humanizeMinutes
import com.artvending.warden.settings
import com.artvending.warden.language
import com.artvending.warden.log
import com.artvending.warden.minutesToTimeString
import com.artvending.warden.myOnClick
import com.artvending.warden.remarks
import com.artvending.warden.commonSettings
import com.artvending.warden.toColor
import com.artvending.warden.todayWorkingTime
import com.artvending.warden.userPikalkaId
import kotlinx.datetime.number
import org.jetbrains.compose.web.ExperimentalComposeWebApi
import org.jetbrains.compose.web.attributes.Draggable
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*


@OptIn(ExperimentalComposeWebApi::class)
@Composable
actual fun Any?.HomeScreen(model: HomeScreenModel) {
	if (settings.NEW_GUI) {
		this as StackScope
		
		HomeScreen_(model)
		return
	}
	
	
	@Composable
	fun CurrentDatetime() {
		Column_({ style { alignSelf(AlignSelf.Center) } }) {
			Span({ style { alignSelf(AlignSelf.Center) } }) {
				Text(model.dateTimeUserData.dateStr)
			}
			Span({ classes(settings.displayFontClass); style { fontWeight("bold");alignSelf(AlignSelf.Center) } }) {
				Text(model.dateTimeUserData.timeStr)
			}
		}
	}
	
	
	@Composable
	fun Status() {
		val fixedTime = model.dateTimeUserData.fixedTime
		val fixedTimeFrom = fixedTime?.from
		val fixedTimeTo = fixedTime?.to
		val late = model.dateTimeUserData.late
		
		var color = Color.black
		var text = ""
		
		if (fixedInterval == null || todayWorkingTime == null || late == null) {
			color = Color.red
			text = " "
		}
		else
			if (fixedTimeTo == null) {
				if (fixedTimeFrom == null)
					if (late > 0) {
						color = Color.red
						text = "${language.YOU_ARE_LATE} ${humanizeMinutes(late)}"
					}
					else {
						color = Color.mediumseagreen
						text = language.YOU_ARE_IN_TIME
					}
				else
					if (late > 0) {
						color = Color.darkred
						text = "${language.YOU_LATED} ${minutesToTimeString(fixedTimeFrom)}"
					}
					else {
						color = Color.mediumseagreen
						text = "${language.INCOME_FIXED} ${minutesToTimeString(fixedTimeFrom)}"
					}
			}
			else {
				if (fixedTimeTo < (todayWorkingTime?.to ?: 100000)) {
					color = Color.darkred
					text = "${language.BAD_OUTCOME_FIXED} ${minutesToTimeString(fixedTimeTo)}"
				}
				else {
					color = Color.mediumseagreen
					text = "${language.OUTCOME_FIXED} ${minutesToTimeString(fixedTimeTo)}"
				}
			}
		
		Span({ style { color(color) } }) {
			Text(text)
		}
	}
	
	
	@Composable
	fun Timeline() {
		Row_({
			classes(settings.labelFontClass)
			style {
				color(settings.opacityGray)
				alignSelf(AlignSelf.Stretch)
				
				if (fixedInterval == null || todayWorkingTime == null)
					property("visibility", "hidden")
			}
		}) {
			Column_({ style { flexGrow(1) } }) {
				val units = model.dateTimeUserData.timelineUnits
				val groups = ArrayList<ArrayList<TimelineUnit>>()
				var currentGroup = ArrayList<TimelineUnit>()
				val lastIndex = units.lastIndex
				
				for ((i, unit) in units.withIndex()) {
					val nextUnit = if (i == lastIndex) null else units[i + 1]
					currentGroup.add(unit)
					
					if (nextUnit == null || nextUnit.mode != unit.mode) {
						groups.add(currentGroup)
						currentGroup = ArrayList<TimelineUnit>()
					}
				}
				
				Row_({ style { height(8.px); alignSelf(AlignSelf.Stretch) } }) {
					for (group in groups) {
						val firstUnitInGroup = group.first()
						
						Div({
							style {
								flexGrow(group.size)
								height(8.px)
								backgroundColor(
									when (firstUnitInGroup.mode) {
										TimelineUnitMode.FIXED_TIME -> Color.mediumseagreen
										TimelineUnitMode.LATE -> rgba(255, 0, 0, 0.5)
										TimelineUnitMode.WORKING_TIME -> rgba(0, 0, 0, 0.28)
										else -> settings.opacityLightGray
									}
								)
							}
						})
					}
				}
				Row_({ style { height(8.px) } }) {
					for (unit in units) {
						val isHour = unit.time % 60 == 0
						
						Column_({ style { flexGrow(1); } }) {
							if (isHour) {
								Div {
									Div({
										style {
											height(3.px);
											width(1.px)
											backgroundColor(settings.opacityLightGray)
										}
									})
									Span({ style { whiteSpace("nowrap"); property("transform", "translate(-50%, 0%)"); property("text-overflow", "clip"); display(DisplayStyle.InlineBlock) } }) {
										Text((unit.time / 60).toString())
									}
								}
							}
						}
					}
					
					val lastUnit = model.dateTimeUserData.timelineUnits.lastOrNull()
					
					if (lastUnit != null)
						Div {
							Div({
								style {
									height(3.px)
									width(1.px)
									backgroundColor(settings.opacityLightGray)
								}
							})
							Div({ style { width(0.px); overflow("visible") } }) {
								Span({ style { whiteSpace("nowrap"); property("transform", "translate(-50%, 0%)"); property("text-overflow", "clip"); display(DisplayStyle.InlineBlock) } }) {
									Text(((lastUnit.time / 60) + 1).toString())
								}
							}
						}
				}
			}
		}
	}
	
	
	@Composable
	fun WorkingTime() {
		Column_({
			style {
				if (fixedInterval == null || todayWorkingTime?.from == null)
					property("visibility", "hidden")
			}
		}) {
			Span({ classes(settings.labelFontClass); style { color(settings.opacityGray) } }) {
				Text(language.YOUR_WORKING_CALENDAR)
			}
			Span({ style { } }) {
				Text("${minutesToTimeString(todayWorkingTime?.from)} - ${minutesToTimeString(todayWorkingTime?.to)}")
			}
		}
	}
	
	
	@Composable
	fun Remarks() {
		if (!commonSettings.SHOW_REMARKS || remarks.isEmpty())
			return
		
		Row_({ style { gap(settings.space); paddingTop(settings.bigSpace); paddingBottom(settings.space) } }) {
			Div({ classes(settings.titleFontClass); style { paddingLeft(settings.space) } }) {
				Text(language.MONTH_REMARKS)
			}
			
			val remarksCount = remarks.groupBy { it.first }.size
			
			Div({
				style {
					marginRight(settings.space)
					property("margin-left", "auto")
					backgroundColor(
						when (remarksCount) {
							1 -> rgba(0, 0, 0, 0.5)
							2 -> rgba(255, 0, 0, 0.5)
							3 -> Color.red
							else -> Color.black
						}
					)
					color(Color.white)
					padding(settings.smallSpace / 4, settings.smallSpace)
					borderRadius(100.px)
				}
			}) {
				Text("$remarksCount из 4-х")
			}
		}
		Card({ style { padding(0.px) } }) {
			Div({ style { display(DisplayStyle.Grid); alignItems(AlignItems.Center); justifyContent(JustifyContent.Center); alignSelf(AlignSelf.Stretch); gridTemplateColumns("[icon] auto [day-of-week] auto [day] auto [remark] auto [space] 1fr") } }) {
				val groups = remarks.groupBy { it.first }
				
				for ((i, group) in groups.toList().withIndex()) {
					val date = group.first
					
					if (i > 0)
						Div({ style { height(1.px); backgroundColor(settings.opacityLightGray); gridColumn(1, 7) } })
					
					val lastIndex = group.second.lastIndex
					
					for ((j, remark) in group.second.withIndex()) {
						Row_({ style { gridColumn(1, 2); alignSelf(AlignSelf.Stretch) }; myOnClick { val d = date; model.remarkClicked(d) } }) {
							if (j == 0)
								Img("warning.svg") { draggable(Draggable.False); style { width(24.px); margin(settings.smallSpace, 0.px, if (j == lastIndex) settings.smallSpace else 0.px, settings.smallSpace); alignSelf(AlignSelf.Center) } }
						}
						Row_({ style { gridColumn(2, 3); alignSelf(AlignSelf.Stretch) }; myOnClick { val d = date; model.remarkClicked(d) } }) {
							if (j == 0)
								Div({ style { margin(settings.smallSpace, 0.px, if (j == lastIndex) settings.smallSpace else 0.px, settings.smallSpace); alignSelf(AlignSelf.Center) } }) {
									Text("${date.getDayOfWeekStr()}. ")
								}
						}
						Row_({ style { gridColumn(3, 4); alignSelf(AlignSelf.Stretch) }; myOnClick { val d = date; model.remarkClicked(d) } }) {
							if (j == 0)
								Div({ style { margin(settings.smallSpace, 0.px, if (j == lastIndex) settings.smallSpace else 0.px, 0.px); alignSelf(AlignSelf.Center); fontWeight("bold"); } }) {
									Text("${date.dayOfMonth.toString().padStart(2, '0')}.${date.month.number.toString().padStart(2, '0')}")
								}
						}
						Row_({ style { gridColumn(5, 6); alignSelf(AlignSelf.Stretch) }; myOnClick { val d = date; model.remarkClicked(d) } }) {
							Div({ style { margin(if (j == 0) settings.smallSpace else 0.px, settings.smallSpace, if (j == lastIndex) settings.smallSpace else 0.px, settings.smallSpace); alignSelf(AlignSelf.Center) } }) {
								val remarkValue = remark.second
								Text(
									if (remarkValue == null)
										language.INCOME_DIDNT_FIX
									else if (remarkValue > 0)
										if (remarkValue == Int.MAX_VALUE)
											language.LATE
										else
											"${language.LATE_ON} ${humanizeMinutes(remarkValue)}"
									else if (remarkValue < 0)
										"${language.BAD_OUTCOME} ${humanizeMinutes(-remarkValue)}"
									else
										language.OUTCOME_DIDNT_FIX
								)
							}
						}
					}
				}
			}
		}
	}
	
	
	@Composable
	fun ProgressBar() {
		println(111)
		if (fixedInterval == null || todayWorkingTime == null) {
			println(222)
			if (userPikalkaId == "") {
				println(333)
				Div({
					style {
						position(Position.Absolute); top(33.percent);left(0.px);right(0.px);bottom(0.px)
						color(Color.darkred); textAlign("center")
					}
				}) {
					Text(language.USER_DIDNT_SET)
				}
			}
			else
				MdLinearProgress(null, { style { margin(0.px, settings.space); position(Position.Absolute); top(33.percent); transform { translateY((-50).percent) };left(0.px);right(0.px);bottom(0.px) } })
		}
	}
	
	
	Div({ style { flexGrow(1) } })
	Card {
		log("HomeScreen()--------------")
		CurrentDatetime()
		Column_({ style { position(Position.Relative);gap(settings.space) } }) {
			Timeline()
			WorkingTime()
			Status()
			ProgressBar()
		}
		MyButton(
			{
				if (allowDevice == true)
					model.go()
			},
			{
				style {
					alignSelf(AlignSelf.Stretch)
					
					if (allowDevice != true)
						property("opacity", "0")
					
					property("--md-filled-button-label-text-color", "white")
					property("--md-filled-button-container-color", model.getButtonColor().toColor())
				}
			}
		) {
			Text(if (fixedInterval?.from == null) language.INCOME else if (fixedInterval?.to == null) language.OUTCOME else language.RE_OUTCOME)
		}
	}
	Remarks()
	Div({ style { flexGrow(1.5) } })
}